import React, { Component, cloneElement, Children } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import autobind from "autobind-decorator";
import get from "lodash/get";

/**
 * 选项卡组件
 */
export default class Tab extends Component {
  constructor() {
    super();
    this.state = {
      children: [],
      defaultActiveKey: "",
      activeKey: ""
    };
  }
  componentWillMount() {
    const { defaultActiveKey, children } = this.props;
    const activeKey = defaultActiveKey || children[0].props.keys;
    this.setState({
      activeKey
    });
  }
  componentWillReceiveProps(nextProps) {
    const { defaultActiveKey } = nextProps;
    if (!defaultActiveKey) {
      return;
    }
    if (defaultActiveKey !== this.state.activeKey) {
      this.handleTabBarClick(defaultActiveKey, false, false);
    }
  }
  @autobind
  addChildPanel(child) {
    const { children } = this.state;
    children.push(child);
    this.setState({
      children
    });
  }
  @autobind
  updateChildPanel(index, newChild) {
    const { children } = this.state;
    children.splice(index, 1, newChild);
    this.setState({
      children
    });
  }
  handleTabBarClick(activeKey, disabled, user) {
    const { beforeChange } = this.props

    if (disabled) {
      return;
    }

    if (user) {
      const shouldChange = beforeChange()

      // 若返回false, 则不进行离开
      if (!shouldChange) {
        return
      }
    }

    this.setState({
      activeKey
    });
    this.props.onChange && this.props.onChange(activeKey);
  }
  renderHeader(children) {
    const { activeKey } = this.state;
    const {
      tabStyle = {},
      activeStyle = {},
      tabClassName,
      activeClassName,
      isTrapezoid
    } = this.props;
    const _className = isTrapezoid
      ? "trapezoid-tab-header-item"
      : "tab-header-item";
    return children.map(({ header, key, context }) => {
      const active = key === activeKey;
      const disabled = context.props.disabled;
      const classes = classNames(_className, {
        [tabClassName]: true,
        active,
        [activeClassName]: active,
        disabled
      });
      const styles = active
        ? Object.assign({}, tabStyle, activeStyle)
        : tabStyle;
      return (
        <div
          className={classes}
          style={styles}
          onClick={() => this.handleTabBarClick(key, disabled, true)}
          key={key}
        >
          {header}
        </div>
      );
    });
  }
  isChildActive(child) {
    return get(child, "props.keys") === this.state.activeKey;
  }
  render() {
    const { children, className, role } = this.props;
    const { children: childPanels } = this.state;
    const classes = classNames("tab-wrap", className);
    return (
      <div className={classes} role={role}>
        <div className="tab-header">{this.renderHeader(childPanels)}</div>
        <div className="tab-content">
          {Children.map(children, (child, index) => {
            const active = this.isChildActive(child);
            if (!child) return null;
            return cloneElement(child, {
              active,
              addChildPanel: this.addChildPanel,
              updateChildPanel: this.updateChildPanel,
              index
            });
          }).filter(item => item)}
        </div>
      </div>
    );
  }
}
Tab.defaultProps = {
  beforeChange: () => true
}
Tab.propTypes = {
  /** 默认active的tab, 默认第一个展示 */
  defaultActiveKey: PropTypes.string,
  /** 切换tab时的回调 */
  onChange: PropTypes.func,
  /** 切换tab前的回调，若返回false，则不进行切换 */
  beforeChange: PropTypes.func,
  /** 定制单个选项卡bar的样式 */
  tabStyle: PropTypes.object,
  /** 激活状态bar的样式 */
  activeStyle: PropTypes.object,
  /** 单独设置bar的className */
  tabClassName: PropTypes.string,
  /** 激活状态下bar的className */
  activeClassName: PropTypes.string,
  /** 使用Trapezoid样式类型  */
  isTrapezoid: PropTypes.bool
};
